import React from 'react';
import { Radio } from 'antd';
import './mfa.scss';
import { MfaMode } from '@pushly/models/lib/enums';
import { FormLayoutRow } from '../../form-layout-row/form-layout-row';
function getMfaLabel(mfaMode) {
  return mfaMode === MfaMode.ADAPTIVE ? 'Adaptive' : 'Mandatory';
}
function getMfaModeOption(mfaMode) {
  return /*#__PURE__*/React.createElement(Radio.Button, {
    value: mfaMode
  }, getMfaLabel(mfaMode));
}
export var AccountMfaModeControl = function AccountMfaModeControl(props) {
  var value = props.value,
    _onChange = props.onChange,
    readonly = props.readonly;
  return /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "MFA Mode",
    value: readonly ? /*#__PURE__*/React.createElement("span", null, getMfaLabel(value)) : /*#__PURE__*/React.createElement(Radio.Group, {
      size: "small",
      buttonStyle: "solid",
      defaultValue: value,
      onChange: function onChange(nextValue) {
        _onChange === null || _onChange === void 0 ? void 0 : _onChange(nextValue.target.value);
      }
    }, getMfaModeOption(MfaMode.ADAPTIVE), getMfaModeOption(MfaMode.MANDATORY)),
    info: {
      inline: true,
      tooltipClassName: 'mfa-mode-tooltip',
      title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Adaptive"), ": Users will be prompted to complete MFA when using a new device, impossible travel distance is detected, or when they are using a suspicious IP address."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Mandatory"), ": If Remember Browser is enabled, users will be prompted to complete MFA once every 30 days or after 7 days without at least one successful login. If Remember Browser is disabled, users will be prompted for MFA every time they login."))
    }
  });
};